<app-import-nav />

<h5 class="mt-3">Upload Encounter Type Eligibilities</h5>

<div class="row g-0" [hidden]="uploading">
  <div class="col-12">
    @if (hasError) {
      <div class="alert alert-danger">
        There was a problem uploading the file.
        <ul class="mt-2">
          @for (error of errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }
    <div>
      <app-file-upload
        [fileType]="'.csv'"
        (uploadStart)="onUploadStart()"
        (uploadCancel)="onUploadCancel()"
        (uploadError)="onUploadError()"
        (uploadComplete)="onUploadComplete($event)"
        />
    </div>
  </div>
</div>
<div class="row g-0" [hidden]="!uploading">
  <div class="col-12">
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
    Uploading File...
  </div>
</div>
<div class="mt-3 border p-3 rounded">
  <strong>File Requirements</strong>
  <ul class="mx-3 ps-2">
    <li class="py-2">
      Possible fields
      <ul class="ps-2">
        <li><code>client_name</code> (required)</li>
        <li><code>encounter_type</code> (required)</li>
        <li><code>eligibility_status</code> (required)</li>
      </ul>
    </li>
    <li class="py-2"><code>.csv</code> only</li>
  </ul>
</div>
